module.exports = __webpack_public_path__ + "static/media/CTLI_16-147w.87d6fccc.jpg";